import Vue from "vue";

//订单状态
Vue.directive("status", function(el, binding) {
  switch (binding.value) {
    case "60":
      el.innerHTML = "已完成";
      break;
    case "30":
      el.innerHTML = "待发货";
      break;
    case "10":
      el.innerHTML = "已取消";
      break;
    default:
      el.innerHTML = "系统异常";
  }
});
//结算单状态
Vue.directive("status2", function(el, binding) {
  switch (binding.value) {
    case "s10":
      el.innerHTML = "待审核";
      break;
    case "s30":
      el.innerHTML = "待打款";
      break;
    case "s60":
      el.innerHTML = "已结单";
      break;
    default:
      el.innerHTML = "系统异常";
  }
});
//结算单状态
Vue.directive("statusHao", function(el, binding) {
  switch (binding.value) {
    case "-1":
      el.innerHTML = "仓库中";
      break;
    case "0":
      el.innerHTML = "出售中";
      break;
    case "1":
      el.innerHTML = "已卖出";
      break;
    default:
      el.innerHTML = "系统异常";
  }
});
//时间戳 转日期
Vue.directive("timer", function(el, binding) {
  let date = new Date(binding.value * 1);
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  M = M < 10 ? "0" + M : M;
  let D = date.getDate();
  D = D < 10 ? "0" + D : D;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  el.innerHTML = Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
});
